<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Application Alias
              <router-link
                :to="{ name: 'ApplicationAliasAdd' }"
                class="btn ml-auto"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Application Alias</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt=""/>
          </div>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <h6>Total Item: {{ list.total }}</h6>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>Device Type</th>
                    <th>Alias</th>
                    <th>Voip Enable</th>
                   
                    <th class="text-right">Action</th>
                  </tr>
                  </thead>
                  <tbody class="list">
                  <tr v-for="(val, index) in list.data" :key="val.id">
                    <td>{{ val.device_type }}</td>
                    <td>{{ val.alias }}</td>
                    <!-- <td>{{ formatDate(val.created_at) }}</td>
                    <td>{{ formatDate(val.updated_at) }}</td> -->
                    <td>{{ val.voip_enable }}</td>

                    <td class="text-right">
                      <router-link
                        v-if="actionEdit == true"
                        :to="{
                          name: 'ApplicationAliasEdit',
                          params: { id: val.id }
                        }"
                        class="btn btn-edit"
                      >
                        <i class="icon-edit"></i>
                      </router-link>
                      <a
                        v-if="actionDelete == true"
                        class="btn btn-trash"
                        href="javascript:void(0)"
                        @click="deleteObject(val.id, index)"
                      >
                        <i class="icon-trash"></i>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>

            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt=""/>
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import {CommonAPI, PermissionChecker} from '@/services/api'
import LocalStorage from '@/services/localStorage'
import axios from 'axios'
import {mapGetters} from 'vuex'

export default {
  name: 'ApplicationAlias',
  metaInfo: {
    title: 'Application Alias | Dotlines'
  },
  components: {
    VuePagination,
    SortIcons
  },
  data: () => ({
    organizationId: LocalStorage.get('organizationId'),
    userEmail: LocalStorage.get('userEmail'),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: false,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: '',
    is_loading: false,
    empty: false,
    empty_message: '',
    has_permission: true,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window
        .$(document)
        .find('.push-menu-class')
        .trigger('click')
    }
    this.api_url = '/application-alias'
    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    })
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    async initialize() {
      this.is_loading = true

      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then(profile_info => {
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }

      // check if "administrator" exists
      let roles = this.user_detail.roles ?? []
      const isAdmin = roles.some((role) => role.slug === "administrator")
      
      if (isAdmin) {
        this.actionCreate = true
        this.actionView = true
        this.actionEdit = true
        this.actionDelete = true
      } else {
        this.actionCreate = false
        this.actionView = true
        this.actionEdit = false
        this.actionDelete = false
      }

      await this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })

      this.is_loading = false
    },

    reload: function () {
      this.getList()
        .then(response => {
          this.list = response.data
        })
        .catch(error => {
          this.empty = true
          if (error.response.status === 403) {
            this.has_permission = false
          }
        })
    },

    getList: function () {
      const _this = this
      return new Promise((resolve, reject) => {
        let params = {page: this.list.current_page}
        params = {
          organizationId: this.organizationId,
          ...params
        }
        axios
          .get(this.api_url, {
            params: params
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            // _this.is_loading = false;
          })
      })
    },

    deleteObject: function (id, index) {
      const _this = this
      const delete_api_url = '/application-alias/' + id

      _this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
        .then(result => {
          if (result.isConfirmed) {
            _this.is_loading = true
            axios
              .delete(delete_api_url)
              .then(response => {
                _this.list.data.splice(index, 1)
                _this.$toaster.success(response.data.message)
                _this.is_loading = false
              })
              .catch(error => {
                _this.is_loading = false
                console.log(error)
                _this.$swal.fire('Failed!', 'failed to delete.', 'error')
              })
              .finally(() => {
                _this.is_loading = false
              })
          }
        })
    },
      checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['edit_id_condition'],
          this.custom_permission_data['edit_refid_condition'],
          this.custom_permission_data['edit_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
      checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['delete_id_condition'],
          this.custom_permission_data['delete_refid_condition'],
          this.custom_permission_data['delete_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },

    // formatDate: function (date) {
    //   if (!date) return ''
    //   const options = { 
    //     year: 'numeric', 
    //     month: 'short', 
    //     day: 'numeric',
    //     hour: '2-digit',
    //     minute: '2-digit'
    //   }
    //   return new Date(date).toLocaleDateString(undefined, options)
    // }
  }
}
</script>